import { useTranslation } from "react-i18next";

const LATITUDE = 50.884831;
const LONGITUDE = 4.094054;
const MAP_URL =
  `https://www.openstreetmap.org/export/embed.html?bbox=4.080054%2C50.876831%2C4.108054%2C50.892831&layer=mapnik&marker=${LATITUDE}%2C${LONGITUDE}`;

const OpenStreetMap = () => {
  const { t } = useTranslation();

  return (
    <iframe
      title={`${t("address")}: Begijnenmeers 8, 1770 Liedekerke`}
      src={MAP_URL}
      width="100%"
      height="400"
      loading="lazy"
      referrerPolicy="strict-origin-when-cross-origin"
      style={{ border: 0, display: "block" }}
    />
  );
};

export default OpenStreetMap;
